import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import Navbar from "../../nav_bar/Navbar";
import Footer from "../../footer/Footer";
import { fetchGrammarSubTopicById } from "./grammarService";
import "./GrammarSubTopicDetailPage.css";

const GrammarSubTopicDetailPage = () => {
  const { subTopicId } = useParams();
  const navigate = useNavigate();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const load = async () => {
      console.log("[GrammarSubTopicDetailPage] Loading sub-topic id:", subTopicId);
      setLoading(true);
      const res = await fetchGrammarSubTopicById(subTopicId);
      if (res.status === 200 && res.data?.status) {
        console.log("[GrammarSubTopicDetailPage] Sub-topic loaded:", res.data.data?.title, "sections:", res.data.data?.sections?.length || 0);
        setData(res.data.data);
      } else {
        console.error("[GrammarSubTopicDetailPage] Load failed:", res.status, res.message);
      }
      setLoading(false);
    };
    load();
  }, [subTopicId]);

  if (loading) return (<><Navbar /><div className="gsd-page"><p className="gsd-loading">Loading...</p></div><Footer /></>);
  if (!data) return (<><Navbar /><div className="gsd-page"><p className="gsd-loading">Sub-topic not found.</p></div><Footer /></>);

  return (
    <>
      <Navbar />
      <div className="gsd-page">
        <button className="gsd-back" onClick={() => navigate(`/study/grammar/${data.grammarTopicId}`)}>
          ← Back to {data.grammarTopicTitle || "Topic"}
        </button>

        <h1 className="gsd-title">{data.title}</h1>
        <p className="gsd-breadcrumb">{data.grammarTopicTitle}</p>

        {data.sections?.map((sec, idx) => (
          <div key={idx} className="gsd-section">
            <h3 className="gsd-section-heading">{sec.heading}</h3>
            <p className="gsd-section-content">{sec.content}</p>
            {sec.example && (
              <div className="gsd-example">
                <span className="gsd-example-label">Example:</span> {sec.example}
              </div>
            )}
            {sec.subSections?.length > 0 && (
              <div className="gsd-subsections">
                {sec.subSections.map((ss, sIdx) => (
                  <div key={sIdx} className="gsd-subsection">
                    <h4 className="gsd-subsection-heading">{ss.heading}</h4>
                    <p className="gsd-section-content">{ss.content}</p>
                    {ss.example && (
                      <div className="gsd-example">
                        <span className="gsd-example-label">Example:</span> {ss.example}
                      </div>
                    )}
                  </div>
                ))}
              </div>
            )}
          </div>
        ))}

        {data.youtubeLink && (
          <div className="gsd-video-card">
            <h3 className="gsd-section-heading">🎬 Video Lesson</h3>
            <div className="gsd-video-wrapper">
              <iframe
                src={data.youtubeLink.replace("watch?v=", "embed/").replace("youtu.be/", "youtube.com/embed/")}
                title={data.title}
                allowFullScreen
                frameBorder="0"
              />
            </div>
          </div>
        )}

        {data.createdAt && (
          <p className="gsd-meta">
            Added on {new Date(data.createdAt).toLocaleDateString("en-IN", { day: "numeric", month: "short", year: "numeric" })}
          </p>
        )}
      </div>
      <Footer />
    </>
  );
};

export default GrammarSubTopicDetailPage;
